export default "__VITE_ASSET__DzKNXLej__"